import {Navbar} from "react-bootstrap";

export default function MainFooter() {
    return (
        <Navbar bg="light">
                  <span
                      className="text-muted">Proudly built in the <a href="https://en.wikipedia.org/wiki/Cascadia_(bioregion)">Cascadia bioregion</a></span>
        </Navbar>
    )
}
